"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _countriesAndTimezones = _interopRequireDefault(require("countries-and-timezones"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://stackoverflow.com/a/56490104
const getTimezoneName = timezone => {
  const today = new Date();
  const short = today.toLocaleDateString(undefined);
  let full;

  try {
    full = today.toLocaleDateString(undefined, {
      timeZoneName: 'long',
      timeZone: timezone
    });
  } catch (error) {
    return null;
  } // Trying to remove date from the string in a locale-agnostic way


  const shortIndex = full.indexOf(short);

  if (shortIndex >= 0) {
    const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length); // by this time `trimmed` should be the timezone's name with some punctuation -
    // trim it from both sides

    return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, '');
  } // in some magic case when short representation of date is not present in the long one,
  // just return the long one as a fallback, since it should contain the timezone's name


  return full;
}; // Some timezone names come with the day prepended to the name. For example "27/10/2022, Samoa Standard Time"


const removeDayFromTimezoneName = name => {
  const n = name.split(',').length > 1 ? name.split(',')[1] : name;
  return n.trim();
};

const updateArray = (initialArray, newValues) => {
  if (!newValues || !newValues.length) {
    return initialArray;
  }

  const newValuesArray = [...(newValues || [])];

  if (!initialArray || !initialArray.length) {
    return newValuesArray;
  }

  return newValuesArray.reduce((acc, newValue) => {
    const alreadyExists = acc.indexOf(newValue) >= 0;
    return alreadyExists ? acc : [...acc, newValue];
  }, initialArray);
};

const getSupportedTimezones = () => {
  const timezones = Object.values(_countriesAndTimezones.default.getAllTimezones());
  const namedTimezones = timezones.reduce((acc, timezone) => {
    const fullName = `${getTimezoneName(timezone.name)}`;
    const name = removeDayFromTimezoneName(fullName);

    if (name.includes('GMT')) {
      return acc;
    }

    if (!acc[name]) {
      const t = { ...timezone,
        countries: timezone.countries,
        aliasList: [timezone.name]
      };
      return { ...acc,
        [name]: t
      };
    }

    acc[name].countries = updateArray(acc[name].countries, timezone.countries);
    acc[name].aliasList = updateArray(acc[name].aliasList, [timezone.name]);
    return acc;
  }, {});
  const supportedTimezones = Object.entries(namedTimezones).map(([name, timezone]) => ({ ...timezone,
    timezone: timezone.aliasOf || timezone.name,
    name,
    dstName: name
  }));
  return supportedTimezones;
};

var _default = {
  getSupportedTimezones
};
exports.default = _default;